// src/App.js
import React, { useState } from 'react';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import BooksPage from './pages/BooksPage';
import UsersPage from './pages/UsersPage';
import AnalyticsPage from './pages/AnalyticsPage';
import BookCategoryPage from './pages/BookCategoryPage';
import SubscriptionPage from './pages/SubscriptionPage';
import GroupsPage from './pages/GroupsPage';
import ImportedBooksPage from './pages/ImportedBooksPage';

const C = {
  rose: '#C97B77', rosePale: '#F9EDEC', roseLt: '#E8B4B1',
  slate: '#6B7FA0', slatePale: '#EEF2F8', slateLt: '#A8B8D0',
  sage: '#7A9E8E', ink: '#2C2C35', inkMid: '#555567', inkLt: '#888899',
  border: '#E8E4DF', white: '#FFFFFF', offWhite: '#FAFAF8', pageBg: '#F5F2EE',
  amber: '#C4975A', amberPale: '#FBF4E8',
};

const NAV = [
  { key: 'dashboard',      icon: '📊', label: 'Dashboard' },
  { key: 'books',          icon: '📚', label: 'Books' },
  { key: 'book-category',  icon: '🏷️', label: 'Book Category' },
  { key: 'subscriptions',  icon: '💎', label: 'Subscriptions' },
  { key: 'users',          icon: '👥', label: 'Users' },
  { key: 'groups',         icon: '🗂️', label: 'Groups' },
  { key: 'analytics',      icon: '📈', label: 'Analytics' },
  { key: 'imported-books', icon: '📥', label: 'Add Books' },
];

export default function App() {
  const [authed, setAuthed] = useState(!!localStorage.getItem('air_admin_token'));
  const [page, setPage] = useState('dashboard');

  if (!authed) return <LoginPage onLogin={() => setAuthed(true)} />;

  const pages = {
    dashboard:        <Dashboard onNav={setPage} />,
    books:            <BooksPage />,
    'book-category':  <BookCategoryPage />,
    subscriptions:    <SubscriptionPage />,
    users:            <UsersPage />,
    groups:           <GroupsPage />,
    analytics:        <AnalyticsPage />,
    'imported-books': <ImportedBooksPage />,
  };

  return (
    <div style={{ display: 'flex', height: '100vh', background: C.pageBg, fontFamily: 'Nunito,system-ui,sans-serif' }}>
      {/* Sidebar */}
      <aside style={{ width: 220, background: C.white, borderRight: `1px solid ${C.border}`, display: 'flex', flexDirection: 'column', flexShrink: 0 }}>
        <div style={{ padding: '20px 20px 16px', borderBottom: `1px solid ${C.border}` }}>
          <div style={{ fontFamily: 'Playfair Display,serif', fontSize: 18, fontWeight: 700, color: C.rose }}>AIR Reader</div>
          <div style={{ fontSize: 10, color: C.inkLt, fontWeight: 700, letterSpacing: 2, textTransform: 'uppercase', marginTop: 2 }}>Admin Panel</div>
        </div>
        <nav style={{ flex: 1, padding: '8px 0' }}>
          {NAV.map(n => (
            <button key={n.key} onClick={() => setPage(n.key)}
              style={{
                width: '100%', display: 'flex', alignItems: 'center', gap: 10, padding: '11px 20px',
                background: page === n.key ? C.rosePale : 'transparent',
                color: page === n.key ? C.rose : C.inkMid, border: 'none', cursor: 'pointer',
                fontSize: 13, fontWeight: 600,
                borderRight: page === n.key ? `3px solid ${C.rose}` : '3px solid transparent',
                fontFamily: 'Nunito,sans-serif', textAlign: 'left'
              }}>
              <span style={{ fontSize: 16 }}>{n.icon}</span>
              {n.label}
            </button>
          ))}
        </nav>
        <div style={{ padding: '16px 20px', borderTop: `1px solid ${C.border}` }}>
          <button onClick={() => { localStorage.removeItem('air_admin_token'); setAuthed(false); }}
            style={{ width: '100%', padding: '8px', background: C.rosePale, color: C.rose, border: `1px solid ${C.roseLt}`, borderRadius: 8, fontSize: 12, fontWeight: 700, cursor: 'pointer', fontFamily: 'Nunito,sans-serif' }}>
            Sign Out
          </button>
        </div>
      </aside>

      {/* Main */}
      <main style={{ flex: 1, overflow: 'auto' }}>
        {pages[page] || pages.dashboard}
      </main>
    </div>
  );
}